module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerut0a-ch0601",
      "epub:type": "division",
      "id": "ut0a-ch06"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerut0a-ch0601"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "24",
      "id": "p24",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20005#toc"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Joint Committee on Reconstruction, Membership")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("1865–1867"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chilashvol20268#fn8",
      "id": "fn8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8*")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ahaft",
    attrs: {
      "id": "ahaft0901"
    }
  }, [_vm._v("Members on the part of the Senate.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Mr.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("William P. Fessenden")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("of Maine [Chair].")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("James W. Grimes,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Iowa.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ira Harris,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ New York.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Jacob M. Howard,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Michigan.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reverdy Johnson,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Maryland.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and “")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("George H. Williams,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Oregon.")])])])])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0901"
    }
  }, [_vm._v("Members on the part of the House of Rep’s.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Mr.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Thaddeus Stevens")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("of Penn’a.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Elihu B. Washburne,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Illinois.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Justin S. Morrill,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Vermont.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Henry Grider,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Kentucky.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("John A. Bingham,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Ohio.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Roscoe Conkling,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ New York.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("George S. Boutwell,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Massachusetts.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Henry T. Blow,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ Missouri.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and “")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Andrew J. Rogers,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“ New Jersey.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24efbfe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lash-vol2-0016.vue
// module id = 99
// module chunks = 0